import { observable } from "mobx";
import { Type } from "class-transformer";
import MonthOfYearRangeResponse from "./monthOfYearRangeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchAccountBalanceCheckRequestsRequest {
  /**
   * Number of records to be selected.
   * @example 20
   */
  @observable
  limit?: number = 100;

  /**
   * Number of records to be skipped before selecting records.
   * @example 1
   */
  @observable
  offset?: number = 0;

  @observable
  @Type(() => MonthOfYearRangeResponse)
  accountingPeriodToMonthRange?: MonthOfYearRangeResponse;
}
